import { translateBackend } from '@assets/i18n/config';
import { SelectionTile } from '@ovComponents/3-pattern/selectionTile/selectionTile';
import { WorkflowCompletionForm } from '@ovComponents/4-module/workflowCompletion/components/workflowCompletionForm';
import { Typography } from 'hephaestus/web';
import type { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

export const TypeSelect = ({
  options,
  onNext,
  data,
  onChangeSetData,
}: {
  options: any;
  onNext: any;
  data: any;
  onChangeSetData: Dispatch<SetStateAction<any>>;
}) => {
  const { t } = useTranslation('client');
  const typeAttribute = options?.typeAttribute || 'type';
  const submit = () => {
    if (data[typeAttribute]) {
      onNext();
    }
  };

  return (
    <WorkflowCompletionForm
      onSubmit={submit}
      submitButtonProps={{
        label: t('continue'),
        dataTestId: 'type-select-continue-button',
      }}
    >
      <Typography variant='displayLarge' sx={{ mt: 1 }}>
        {translateBackend(options?.title)}
      </Typography>
      <Typography variant='bodyLarge' sx={{ mb: 3 }}>
        {translateBackend(options?.subtitle)}
      </Typography>
      <SelectionTile
        testId='entity-type-select'
        onChange={(e: any) =>
          onChangeSetData((prev: any) => ({
            ...prev,
            [typeAttribute]: e.target.value,
          }))
        }
        value={data[typeAttribute]}
        options={options?.options?.map((option: any) => ({
          value: option.value,
          label: translateBackend(option.label),
          subtitle: translateBackend(option.description),
        }))}
      />
    </WorkflowCompletionForm>
  );
};

export default TypeSelect;
